import React, {useEffect, useState} from 'react';
import FileSaver from 'file-saver';
import {utils, write} from 'xlsx';
import {Button as ButtonBase, ButtonProps, IconButton, styled, Tooltip} from '@mui/material';
import {GetApp} from '@mui/icons-material';
import {pickBy} from 'lodash';
import Iconify from '../Iconify/Iconify';

const Button = styled(ButtonBase)(({theme}) => ({
  backgroundColor: theme.palette.background.paper,
  color: theme.palette.text.primary,
}));

export interface ExportExcelButtonProps {
  title?: string;
  data: {[key: string]: any}[];
  fileName: string;
  headers: [{[key: string]: any}];
  children?: React.ReactNode;
}

const ExcelExport: React.FC<ButtonProps & ExportExcelButtonProps> = ({data, title, fileName, headers, ...rest}) => {
  const fileType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
  const fileExtension = '.xlsx';

  const convertHeadersForExportExcel: any = () => {
    const temp: any = {};
    headers?.forEach((header: any) => {
      if (header.export !== false) {
        temp[header?.id] = header?.label;
      }
    });

    return [temp];
  };

  const exportToExcel = () => {
    const _headers = convertHeadersForExportExcel();
    const ws = utils.json_to_sheet(_headers, {
      header: Object.keys(_headers[0]).map(k => k),
      skipHeader: true,
    });

    const d = data.map(item => pickBy(item, (prop: any, key: any) => _headers?.[0]?.[key]));

    utils.sheet_add_json(ws, d, {
      header: Object.keys(_headers[0]).map(k => k),
      skipHeader: true,
      origin: -1, //ok
    });

    const wb = {Sheets: {data: ws}, SheetNames: ['data']};
    const excelBuffer = write(wb, {bookType: 'xlsx', type: 'array'});

    const _data = new Blob([excelBuffer], {type: fileType});
    FileSaver.saveAs(_data, fileName + fileExtension);
  };

  return (
    <Tooltip title="Export Excel">
      <IconButton
        onClick={e => {
          exportToExcel();
        }}
        {...rest}
      >
        <Iconify sx={{width: 30, height: 30}} color="#fff" icon="file-icons:microsoft-excel" />
      </IconButton>
    </Tooltip>
  );
};

export default ExcelExport;
